<template>
    <v-row>
        <v-col cols="12">
            <TableV nombre="Usuarios Coordinador" :table="user" :type="type" :headerss="header" :loadings="loading" />
        </v-col>
    </v-row>    
</template>
<script>

import Table from '../../../../component/helpers/tools/table'
import Single from '../../../../component/helpers/tools/single'
import TableV from '../../../../component/helpers/tools/tablesearchVehiculo'

export default {
    
    components:{
        Table,
        Single,
        TableV
    },

    data() {
        return {
            type:'usuarios',
            header: [
                {
                    text: 'Usuario Coordinador',
                    align: 'left',
                    sortable: false,
                    value: 'name',
                },
                { text: 'Correo', align: 'right', value: 'email' },
                { text: 'Estado', align: 'right', value: 'status' },
                
                
                
                
            ]
        }
    },

    computed: {
    
        user(){
            return this.$store.state.users_supervisor;
        },

        loading(){
            return this.$store.state.loading_dashboard
        },


    },

}
</script>